// extracted by mini-css-extract-plugin
export default {"buttons":"rejectStepConfirmationModal_buttons__YN6nH"};